module.exports = __webpack_public_path__ + "img/Doc08-20060136-001.a6bddcb4.jpg";